import apiService from '@/services/apiService';

const actions = {
  getBasicServices({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelmarket/basic-service/find-with-paging', payload)
        .then((response) => {
          commit('SET_BASIC_SERVICES', response.data.data.results);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getBasicService({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`paxelmarket/basic-service/${payload}`)
        .then((response) => {
          commit('SET_BASIC_SERVICE', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  orderBasicService({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxelmarket/basic-service/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postBasicService({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelmarket/basic-service', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putBasicService({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxelmarket/basic-service/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delBasicService({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.delete(`paxelmarket/basic-service/${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
    });
  },

};

export default actions;